import React, { Component } from "react";
import { Card, CardBody, TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";
import GeneralMealForm from "./GeneralMealPlan";
import DailyMealPlan from "./DailyMealPlan";
import { mealPlanService } from "./services/mealPlan.services";
import { toast } from "react-toastify";

class ManageMealPlan extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: "1",
            submitted: false,
            submitting: false,
            dailySubmitted: false,
            dailySubmitting: false,
            formResponse: null,
            formError: null,
            totalDays: 0,
            daysLeft: 0,
            days: 0,
            mealPlanId: null,
        };
    }

    createInitialMealPlan = async (data) => {
        this.setState({
            ...this.state,
            submitting: true,
            submitted: false,
            formResponse: null,
            formError: null,
        });
        try {
            let response = await mealPlanService.addFirstInitialStage(data);
            if (response) {
                toast.success("Meal Plan saved successfully", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 4000,
                });

                this.setState({
                    ...this.state,
                    submitting: false,
                    submitted: true,
                    formResponse: null,
                    formError: null,
                    totalDays: response.data.durationDays,
                    mealPlanId: response.data.id,
                });
            }
        } catch (error) {
            this.setState({
                ...this.state,
                formError: error,
                submitting: false,
            });
        }
    };
    submitDailyMealPlan = async (data, day) => {
        const { mealPlanId } = this.state;
        this.setState({
            ...this.state,
            dailySubmitting: true,
            dailySubmitted: false,
            formResponse: null,
            formError: null,
        });
        try {
            let response = await mealPlanService.submitDailyMealPlan(data, mealPlanId);
            if (response) {
                toast.success(`Day ${day} Meal Plan saved successfully`, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 4000,
                });

                this.setState({
                    ...this.state,
                    dailySubmitting: false,
                    dailySubmitted: true,
                    formResponse: null,
                    formError: null,
                });
            }
        } catch (error) {
            this.setState({
                ...this.state,
                formError: error,
                dailySubmitting: false,
            });
        }
    };

    sentToAdminForApproval = async () => {
        const { mealPlanId } = this.state;
        this.setState({
            ...this.state,
            dailySubmitting: true,
            dailySubmitted: false,
            formResponse: null,
            formError: null,
        });
        try {
            let response = await mealPlanService.sendForApproval(mealPlanId);

            if (response == null) {
                toast.success(` Meal Plan sent successfully`, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 4000,
                });

                this.setState({
                    activeTab: "1",
                    submitted: false,
                    submitting: false,
                    dailySubmitted: false,
                    dailySubmitting: false,
                    formResponse: null,
                    formError: null,
                    totalDays: 0,
                    daysLeft: 0,
                    days: 0,
                    mealPlanId: null,
                });
            }
        } catch (error) {
            this.setState({
                ...this.state,
                formError: error,
                dailySubmitting: false,
            });
        }
    };

    submitMealPlan = () => {
        const { mealPlanId } = this.state;

        if (mealPlanId) {
            this.sentToAdminForApproval();
        }
    };
    componentDidMount() {}

    handleSubmit = (data, day) => {
        if (this.state.mealPlanId) {
            this.submitDailyMealPlan(data, day);
        } else {
            this.createInitialMealPlan(data);
        }
    };
    resetDailyMealPlan = () => {
        this.setState({ dailySubmitted: false });
    };

    render() {
        const { activeTab, submitted, submitting, formError, mealPlanId, totalDays, dailySubmitted, dailySubmitting } = this.state;

        return (
            <div>
                <Card>
                    <CardBody>
                        <Nav tabs style={{ borderBottom: " 1px solid #1B415D " }} className="mb-3">
                            <NavItem>
                                {" "}
                                <NavLink
                                    className={classnames({ active: activeTab === "1" })}
                                    style={{
                                        borderColor: " #1B415D #1B415D #fff ",
                                    }}
                                >
                                    {mealPlanId ? "Create Daily Meal Plan" : " General Description"}
                                </NavLink>
                            </NavItem>
                        </Nav>
                        {mealPlanId ? (
                            <TabContent activeTab={activeTab}>
                                <TabPane tabId="1">
                                    <DailyMealPlan mealId={mealPlanId} totalNumDays={totalDays} submitted={dailySubmitted} submitting={dailySubmitting} formError={formError} handleSubmit={this.handleSubmit} dailyReset={this.resetDailyMealPlan} submitToAdmin={this.submitMealPlan} />
                                </TabPane>
                            </TabContent>
                        ) : (
                            <TabContent activeTab={activeTab}>
                                <TabPane tabId="1">
                                    <GeneralMealForm submitted={submitted} submitting={submitting} formError={formError} handleSubmit={this.handleSubmit} />
                                </TabPane>
                            </TabContent>
                        )}
                    </CardBody>
                </Card>
            </div>
        );
    }
}

export default ManageMealPlan;
